import * as api from '../api'
import { FETCH_ALL_ACTULIVE, CREATE_ACTULIVE, DELETE_ACTULIVE, UPDATE_ACTULIVE } from '../constants/actionTypes.js'
import { contrainteNotification, deleteContrainteNotification } from './notifications.js'

// Action creator
export const getActuLives = () => async (dispatch) => {

    try{
        const {data} = await api.fetchActuLives()

        dispatch({ type: FETCH_ALL_ACTULIVE, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const createActuLive = (actulive) => async (dispatch) => {
    try {

        const { data } = await api.createActuLive(actulive)

        dispatch( { type : CREATE_ACTULIVE, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const updateActuLive = (id, actulive) => async (dispatch) => {
    try {
        
        const { data } = await api.updateActuLive(id, actulive)

        dispatch({ type : UPDATE_ACTULIVE, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const deleteActuLive = (id) => async (dispatch) => {
    try {
        await api.deleteActuLive(id)

        dispatch(deleteContrainteNotification(id))

        dispatch({ type : DELETE_ACTULIVE, payload: id})
    }catch(error){
        const {error : serverError} = error.response.data

        const {statusCode, type, typeObject, idObject} = serverError

        if(statusCode===409 && type==='constraint'){
            // Un autre object doit etre supprimé avant
            dispatch(contrainteNotification(idObject, typeObject))
        }
    }
}